import { TextField } from '@mui/material'
import React from 'react'

const SimpleTextField = (props) => (
  <TextField
    label={props.label}
    {...props}
    value={props.value ?? ''}
    onChange={props.onChange}
    autoComplete='off'
    type={props.type ?? 'text'}
    fullWidth
    name="antext"
    onWheel={(e) => e.target.blur()}
  />
)

export default SimpleTextField
